<template>
  <div class="receivingAddressContent main-wrap">
    <div class="main-top">
      <!-- <el-button icon="iconfont icondaoru" type="primary" plain @click="importOrder" class="h40">{{ $lang('批量导入') }}</el-button> -->
      <!-- <el-button icon="iconfont iconxiazai" type="primary" plain @click="downloadAddressTemplate" class="h40">{{ $lang('下载模板') }}</el-button> -->
      <el-button type="primary" @click="rowAdd" icon="iconfont iconxinzeng" class="h40">{{ $lang('新增退回地址') }}</el-button>
      <div class="searchParam">
        <div class="searchParamInput">
          <el-input v-model="searchParam" :placeholder="$lang('姓名/联系电话/地址')" style="width: 336px !important"></el-input>
        </div>
        <el-button type="primary" @click="searchChange" icon="iconfont iconchaxun" class="h32 search">{{ $lang('查询') }}</el-button>
        <el-button type="primary" @click="resetSearch" plain icon="iconfont iconshanchu" class="h32">{{ $lang('清空') }}</el-button>
      </div>
    </div>
    <el-alert type="success" center v-if="showImportResult" @close="closeAlert">
      <div>{{ $lang('本次总共导入') }}{{ allLength }}{{ $lang('条数据') }}，{{ successLength }}{{ $lang('条导入成功') }}，{{ errorLength }}{{ $lang('条导入失败') }}。</div>
    </el-alert>
    <div class="main-table">
      <JmsTableScroll
        :option="listOpt"
        :data="tableList"
        :page="page"
        :table-loading="loading"
        @row-edit="rowEdit"
        @row-del="rowDel"
        @size-change="sizeChange"
        @select-change="selectionChange"
        @current-change="currentChange"
      >
        <template slot="isDefault" slot-scope="data">
          <el-switch v-model="data.row.isDefault" active-color="#13ce66" inactive-color="#dcdfe6" :active-value="1" :inactive-value="2" disabled> </el-switch>
        </template>
      </JmsTableScroll>
    </div>
    <el-dialog
      :title="diglogTitle"
      v-if="editDialogVisible"
      :visible.sync="editDialogVisible"
      width="920px"
      @close="handleClose"
      :modal-append-to-body="false"
      :close-on-click-modal="false"
    >
      <el-form class="el-form-edit" ref="tableForm" :rules="rules" :inline="true" :model="rowData" label-position="left" label-suffix=" :">
        <el-form-item :label="$lang('姓名')" prop="name" class="myDetailItem">
          <el-input v-model="rowData.name" :minlength="1" :maxlength="30" :placeholder="$lang('请输入姓名')"></el-input>
        </el-form-item>
        <el-form-item :label="$lang('手机')" prop="mobile" class="myDetailItem formPhone">
          <!-- <el-input v-model="rowData.mobile" :maxlength='15' :placeholder="$lang('请输入手机')"></el-input> -->
          <BasePhoneInput :maxlength="16" :value="phoneVal" v-model="rowData.mobile"></BasePhoneInput>
        </el-form-item>
        <el-form-item :label="$lang('备用手机')" prop="reserveMobile" class="myDetailItem formPhone">
          <BasePhoneInput :maxlength="16" :value="phoneVal" v-model="rowData.reserveMobile"></BasePhoneInput>
        </el-form-item>
        <el-form-item :label="$lang('公司')" prop="companyName" class="myDetailItem">
          <el-input v-model="rowData.companyName" :placeholder="$lang('请输入公司')"></el-input>
        </el-form-item>
        <!-- <el-form-item :label="$lang('邮编')" prop="postalCode" class="myDetailItem">
          <template slot="label"
            ><span :title="$lang('邮编')">{{ $lang('邮编') }}</span></template
          >
          <el-input v-model="rowData.postalCode" :placeholder="$lang('请输入邮编')" :minlength="1" :maxlength="20"></el-input>
        </el-form-item> -->
        <el-form-item :label="$lang('邮箱')" prop="email" class="myDetailItem">
          <template slot="label"
            ><span :title="$lang('邮箱')">{{ $lang('邮箱') }}</span></template
          >
          <el-input v-model="rowData.email" :minlength="1" :placeholder="$lang('请输入邮箱')" :maxlength="30"></el-input>
        </el-form-item>
        <!-- <el-form-item :label="$lang('省/市/区')" prop="province" class="myDetailItem">
          <BaseAddress ref="provinceSearch" :initAddressData="initAddressData" :showLevel="3" v-model="rowData.province"> </BaseAddress>
        </el-form-item> -->
        <el-form-item :label="provinceName" prop="provinceName" class="myDetailItem">
          <el-select v-model="rowData.provinceName" filterable @change="dataProvinceChange($event)">
            <el-option v-for="item in provinceArray" :key="item.id" :label="item.nativeName" :value="item.id" />
          </el-select>
        </el-form-item>
        <el-form-item :label="cityName" prop="cityName" class="myDetailItem">
          <el-select v-model="rowData.cityName" filterable @change="dataCityChange($event)">
            <el-option v-for="item in cityList" :key="item.id" :label="item.nativeName" :value="item.id" />
          </el-select>
        </el-form-item>
        <el-form-item :label="areaName" prop="areaName" class="myDetailItem" v-if="countryId === 1">
          <el-select v-model="rowData.areaName" filterable @change="dataAreaChange($event)">
            <el-option v-for="item in areaList" :key="item.id" :label="item.nativeName" :value="item.id" />
          </el-select>
        </el-form-item>
        <el-form-item :label="$lang('街道')" prop="street" class="myDetailItem">
          <template slot="label"
            ><span :title="$lang('街道')">{{ $lang('街道') }}</span></template
          >
          <el-input v-model="rowData.street" :placeholder="$lang('请输入街道')" :minlength="1" :maxlength="20" />
        </el-form-item>
        <el-form-item :label="$lang('详细地址')" prop="detailedAddress" class="addressDeatil">
            <el-input v-model="rowData.detailedAddress" :placeholder="$lang('请输入退回人所在街道以及详细地址')" :minlength="1" :maxlength="200"></el-input>
        </el-form-item>
        <el-form-item v-if="countryId === 1" :label="$lang('退回短地址')" prop="shortAddress">
          <template slot="label"><span :title="$lang('退回短地址')">{{ $lang('退回短地址') }}</span></template>
          <el-input v-model="rowData.shortAddress" :placeholder="$lang('请输入退回短地址')" :minlength="1" :maxlength="8" @blur="judgeShortAddress(rowData)" />
        </el-form-item>
        <el-form-item v-if="countryId === 1" :label="$lang('退回辅助编号')" prop="referenceNumber">
          <template slot="label"><span :title="$lang('退回辅助编号')">{{ $lang('退回辅助编号') }}</span></template>
          <el-input v-model="rowData.referenceNumber" :placeholder="$lang('请输入退回辅助编号')" :minlength="1" :maxlength="20"/>
        </el-form-item>
        <el-form-item v-if="countryId === 1" :label="$lang('退回建筑物编号')" prop="buildingNumber">
          <template slot="label"><span :title="$lang('退回建筑物编号')">{{ $lang('退回建筑物编号') }}</span></template>
          <el-input v-model="rowData.buildingNumber" :placeholder="$lang('请输入退回建筑物编号')" :minlength="1" :maxlength="20"/>
        </el-form-item>
        <el-form-item :label="$lang('设为默认')" prop="isDefault1">
          <el-switch v-model="rowData.isDefault" active-color="#13ce66" inactive-color="#ddd" :active-value="1" :inactive-value="2"> </el-switch>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" :loading="keyBtn" @click="handleSubmit('tableForm')" class="h40 h104">{{ $lang('保存') }}</el-button>
      </div>
    </el-dialog>
    <BatchUpload v-model="upload" :orderTemplate="excelImport" @success="uploadSuccess"></BatchUpload>
  </div>
</template>

<script>
import JmsTableScroll from '@/components/jms-widget/jms-table-scroll'
import { RESPONSE_SUCCESS } from '@constants'
import mixin from '@/mixins/mixin.js'
// import BatchUpload from '@/views/place-order/batch-order/BatchUpload'
import BatchUpload from './BatchUpload'
import {
  addAddress,
  reqAddressList,
  updateAddress,
  delAddress,
  downloadAddressTemplate,
  judgeShortAddress
} from '@/api/module/customer'
import { RULES, checkAddressFormat, isNull, phoneAndMobile } from '@utils/rules'
import * as Api from '@api/base/public'
export default {
  name: 'ReceivingAddress',
  components: {
    JmsTableScroll,
    BatchUpload,
  },
  mixins: [mixin],
  data () {
    return {
      COM_HTTP: {
        reqList: reqAddressList,
        reqAdd: addAddress,
        reqUpdate: updateAddress,
        reqDel: delAddress,
      },
      analysisAddress: '',
      keyBtn: false,
      excelImport: 3, // 导入模板
      upload: false,
      showImportResult: false, // 控制导出结果显示
      OrderTemplate: 0, // 模板弹窗,1为下载,2为导入
      diglogTitle: this.$lang('新增退回地址'),
      flag: true,
      searchParam: '',
      value: '',
      phoneVal: '',
      rowData: {
        name: '',
        mobile: '',
        reserveMobile: '',
        provinceId: '',
        provinceName: '',
        cityId: '',
        cityName: '',
        areaId: '',
        areaName: '',
        street: '',
        detailedAddress: '',
        isDefault: 2,
        type: 3,
        id: '',
        companyName: '',
        // postalCode: '',
        email: '',
        shortAddress: '',
        buildingNumber: '',
        referenceNumber: ''
      },
      initAddressData: {
        formProps: {
          provinceIdProp: 'provinceId',
          provinceNameProp: 'provinceName',
          cityIdProp: 'cityId',
          cityNameProp: 'cityName',
          areaIdProp: 'areaId',
          areaNameProp: 'areaName',
        },
        isShowLastLevel: false,
        defaultData: {
          provinceId: '',
          provinceName: '',
          cityId: '',
          cityName: '',
          areaId: '',
          areaName: '',
        },
      },
      tableList: [],
      isRowDetailUrl: false,
      provinceArray: [], // 酋长国
      cityList: [], // 城市
      areaList: [], // 区域
      rules: {
        name: [RULES.required, { validator: isNull }],
        mobile: [RULES.required, { validator: phoneAndMobile }],
        reserveMobile: [{ validator: phoneAndMobile }],
        province: [RULES.requiredSelect],
        detailedAddress: [RULES.required, { validator: checkAddressFormat }],
        provinceName: [RULES.requiredSelect],
        cityName: [RULES.requiredSelect],
        shortAddress: [RULES.codeNumber],
        buildingNumber: [RULES.twenty],
        referenceNumber: [RULES.twenty],
        // areaName: [RULES.requiredSelect],
        // areaName: [RULES.required, { validator: checkAddressFormat }],
      },
      delTitObj: {
        title: this.$lang('删除退回地址'),
        subTitle: this.$lang('你确定要删除该退回地址吗？'),
        threeTitle: '',
      },
      // 21117,多国合一，根据用户的国家code，行政区域的label有变化，下面是沙特(原来)的行政区划
      provinceName: this.$lang('退回省份'),
      cityName: this.$lang('退回城市'),
      provinceName1: this.$lang('退回省份'),
      cityName1: this.$lang('退回城市'),
      areaName: this.$lang('退回区域'),
    }
  },
  computed: {
    countryCode () {
      return this.$store.state.base.user.countryCode || ''
    },
    countryId () {
      return this.$store.state.base.user.countryId || ''
    },
    listOpt () {
      const that = this
      return {
        fixHeight: 115,
        border: true,
        selection: false,
        menu: this.flag,
        menuWidth: 150,
        // rowKey: '$index',
        viewBtn: false,
        column: [
          {
            label: '退回人姓名',
            prop: 'name',
          },
          {
            label: '退回人手机', //  扫描员
            prop: 'mobile',
          },
          {
            label: '退回人备用手机号码',
            prop: 'reserveMobile',
            width: 140,
          },
          {
            // label: '省份',
            label: that.provinceName1,
            prop: 'provinceName',
          },
          {
            // label: '退回城市',
            label: that.cityName1,
            prop: 'cityName',
          },
          {
            label: that.areaName,
            prop: 'areaName',
            show: that.countryId === 1
          },
          {
            label: '退回街道',
            prop: 'street',
          },
          {
            label: '退回详细地址',
            prop: 'detailedAddress',
          },
          {
            label: '退回短地址',
            prop: 'shortAddress',
          },
          {
            label: '退回辅助编号',
            prop: 'referenceNumber',
          },
          {
            label: '退回建筑物编号',
            prop: 'buildingNumber',
          },
          {
            label: '邮箱',
            prop: 'email',
          },
          {
            label: '退回人公司',
            prop: 'companyName',
          },
          // {
          //   label: '邮编',
          //   prop: 'postalCode',
          // },
          {
            label: '是否默认',
            prop: 'isDefault',
            slot: true,
          },
          {
            label: '创建人',
            prop: 'userName',
          },
        ],
      }
    },
  },
  watch: {
    'countryCode': {
      handler (val) {
        const that = this
        if (val === 'UAE') {
          // 阿联酋的用户行政区域要变
          that.provinceName = that.$lang('退回酋长国')
          that.cityName = that.$lang('退回区域')
          that.provinceName1 = that.$lang('退回酋长国')
          that.cityName1 = that.$lang('退回区域')
        }
      },
      immediate: true,
    },
  },
  created () {
    this.getProList()
  },
  methods: {
    async judgeShortAddress(rowData) {
      if (!rowData?.shortAddress) {
        rowData.shortAddress = ''
        return
      }
      const regex = /^[A-Za-z]{4}\d{4}$/
      if (!regex.test(rowData.shortAddress)) {
        rowData.shortAddress = ''
        this.$message.error(this.$lang('不符合短地址规则'))
        return
      }
      try {
        const { code, data } = await judgeShortAddress({
          shortAddress: rowData.shortAddress
        })
        if (code !== RESPONSE_SUCCESS || data !== true) {
          rowData.shortAddress = ''
          this.$message.error(this.$lang('未查询到短地址信息,请输入正确的短地址'))
        }
      } catch (error) {
        rowData.shortAddress = ''
      }
    },
    // 获取酋长国数据
    async getProList () {
      const { data, code, msg } = await Api.GET_AREA({ current: 1, size: 9999, type: 2 })
      if (code === RESPONSE_SUCCESS) {
        this.provinceArray = data
      } else {
        this.$message.error(msg)
      }
    },
    // 选中获取值
    dataProvinceChange (value) {
      this.getCityList(value)
    },
    // 获取城市数据
    async getCityList (parentId) {
      const { data, code, msg } = await Api.GET_AREA({ current: 1, size: 9999, type: 3, parentId: parentId })
      if (code === RESPONSE_SUCCESS) {
        this.cityList = data
        this.rowData.provinceId = parentId
        this.rowData.cityId = data[0].id
        this.rowData.cityName = data[0].nativeName
        let obj = {}
        obj = this.provinceArray.find((item) => {
          return item.id === parentId
        })
        this.rowData.provinceName = obj.nativeName
      } else {
        this.$message.error(msg)
      }
    },
    // 选中城市
    dataCityChange (value) {
      console.log(value)
      this.rowData.cityId = value
      const obj = this.cityList.find((item) => {
        return item.id === value
      })
      this.rowData.cityName = obj.nativeName
      if (this.countryId === 1) { // 1- 沙特  2-阿联酋 (沙特显示区域，阿联酋不显示)
        this.getAreaList(value)
      }
    },
    // 获取区域数据
    async getAreaList(parentId) {
      const { data, code, msg } = await Api.GET_AREANEW({ current: 1, size: 9999, type: 4, parentId: parentId })
      if (code === RESPONSE_SUCCESS) {
        this.areaList = data
        this.rowData.areaId = data[0].id
        this.rowData.areaName = data[0].nativeName
      } else {
        this.$message.error(msg)
      }
    },
    // 选中区域
    dataAreaChange(value) {
      this.rowData.areaId = value
      const obj = this.areaList.find((item) => {
        return item.id === value
      })
      this.rowData.areaName = obj.nativeName
    },
    getParams () {
      return {
        type: 3,
        keyword: this.searchParam,
      }
    },
    // 批量导入
    importOrder () {
      this.upload = true
    },
    uploadSuccess (data) {
      this.showImportResult = true
      this.showBulkResult = false
      this.upload = false
      this.OrderTemplate = 0
      const successList = data.data.success || []
      const failList = data.data.fail || []
      this.successOrightList = successList
      this.failOrightList = failList
      this.allLength = successList.length + failList.length
      this.errorLength = failList.length
      this.successLength = successList.length
      if (this.failOrightList.length > 0) {
        this.tabActive = 1
        this.originList = failList
      } else {
        this.tabActive = 0
        this.originList = successList
      }
      this.multipleSelection = []
      this.isSelectAll = false
      this.pageChange()
    },
    closeAlert () {
      this.showBulkResult = false
      this.showImportResult = false
    },
    // 分割数据
    pageChange () {
      this.originArr = this.splitArray(this.originList)
      this.list = this.originArr[0]
      this.current = 0
      // 触发按钮查询
      this.searchChange()
    },
    splitArray (arr) {
      const a_len = arr.length
      const result = []
      for (let i = 0; i < a_len; i += this.size) {
        result.push(arr.slice(i, i + this.size))
      }
      return result
    },
    // 下载模板
    async downloadAddressTemplate () {
      const res = await downloadAddressTemplate()
      if (res) {
        const enc = new TextDecoder('utf-8')
        let errorData = { code: null }
        try {
          errorData = JSON.parse(enc.decode(new Uint8Array(res))) // 转化成json对象
        } catch (error) {
          // errorData.code = null
        }
        if (errorData.code) {
          this.$message.error(errorData.msg)
        } else {
          if (!!window.ActiveXObject || 'ActiveXObject' in window) {
            // IE
            const name = this.$lang('下载地址模板')
            window.navigator.msSaveOrOpenBlob(res, `${name}.xls`)
          } else {
            // 火狐谷歌都兼容
            const url = window.URL.createObjectURL(new Blob([res], { type: 'application/vnd.ms-excel;charset=utf-8' }))
            const elink = document.createElement('a')
            elink.style.display = 'none'
            elink.href = url
            const name = this.$lang('下载地址模板')
            elink.setAttribute('download', `${name}.xls`)
            document.body.appendChild(elink)
            elink.click()
            URL.revokeObjectURL(elink.href) // 释放URL 对象
            document.body.removeChild(elink)
          }
        }
      }
    },
    // 关闭模板弹窗
    closeTemplate () {
      this.OrderTemplate = 3
    },
    beforeSubmit() {
      return { ...this.rowData, type: 3 }
    },
    // 弹窗关闭前
    beforehandleClose () {
      this.diglogTitle = this.$lang('新增退回地址')
      this.cityList = []
    },
    // 重新处理字段不一的查看字段
    handleData (row) {
      this.diglogTitle = this.$lang('编辑地址')
      this.getCityInfo(row.provinceId)
      this.getAreaInfo(row.cityId)
      return { ...row, type: 3 }
    },
    // 查询城市数据
    async getCityInfo (provinceId) {
      const { data, code, msg } = await Api.GET_AREA({ current: 1, size: 9999, type: 3, parentId: provinceId })
      if (code === RESPONSE_SUCCESS) {
        this.cityList = data
      } else {
        this.$message.error(msg)
      }
    },
    // 查询区域数据
    async getAreaInfo (provinceId) {
      const { data, code, msg } = await Api.GET_AREANEW({ current: 1, size: 9999, type: 4, parentId: provinceId })
      if (code === RESPONSE_SUCCESS) {
        this.areaList = data
      } else {
        this.$message.error(msg)
      }
    },
    // 重置搜索
    resetSearch () {
      this.searchParam = ''
    },
    clearFormItem () {
      this.rowData = {
        name: '',
        mobile: '',
        reserveMobile: '',
        provinceId: '',
        provinceName: '',
        cityId: '',
        cityName: '',
        areaId: '',
        areaName: '',
        street: '',
        detailedAddress: '',
        isDefault: 2,
        type: 3,
        id: '',
        province: {},
        // postalCode: '',
        email: '',
        shortAddress: '',
        buildingNumber: '',
        referenceNumber: ''
      }
      this.$refs['tableForm'].resetFields()
    },
  },
}
</script>

<style lang="scss" scoped>
.formPhone {
  ::v-deep .el-form-item__label {
    width: 220px !important;
  }
}
.formPhone {
  ::v-deep .el-form-item__content {
    width: 220px !important;
  }
}
.oper {
  position: absolute;
  right: 20px;
  bottom: 5px;
  cursor: pointer;
  color: #333;
  .red {
    color: red;
    margin-right: 20px;
  }
}
.el-table th.gutter {
  display: table-cell !important;
}
.receivingAddressContent {
  .main-top {
    padding: 16px 24px;
    background-color: #fff;
  }
  .main-table {
    padding: 12px 24px;
    background: #edeef3;
    flex: 1;
  }
  .searchParam {
    margin-top: 10px;
    display: inline-flex;
    width: 100%;
    position: relative;
    .searchParamInput {
      padding-right: 16px;
    }
    .el-button {
      height: 32px;
    }
    .buttons {
      position: absolute;
      right: 0;
      height: 32px;
    }
  }
  .dot {
    margin-right: 5px;
    width: 6px;
    height: 6px;
    background: #999;
    display: inline-flex;
    vertical-align: middle;
    border-radius: 50%;
    &.yellow {
      background: #ffa111;
    }
    &.green {
      background: #00da00;
    }
    // &.active::before {
    //   background: rgba(0, 218, 0, 1);
    // }
  }
  .el-dialog {
    .el-dialog__body {
      .myDetail {
        display: inline-flex;
        padding: 0 0 24px 0;
        .myDetailItem {
          width: 200px;
          padding: 0 8px;
          .myDetailItemText {
            padding-bottom: 4px;
          }
        }
      }
      .addressDeatil {
        .el-input {
          width: 360px !important;
        }
      }
    }
    .reuqire {
      color: red;
    }
    .el-dialog__header {
      padding: 12px 25px !important;
      border-bottom: 1px solid #eeeeee;
    }
  }
}
.dot {
  margin-right: 5px;
  width: 6px;
  height: 6px;
  background: #999;
  display: inline-flex;
  vertical-align: middle;
  border-radius: 50%;
  &.yellow {
    background: #ffa111;
  }
  &.green {
    background: #00da00;
  }
}
.tableHead {
  background: #fafafa;
}
</style>

<style lang="scss">
.receivingAddressContent {
  .el-table__fixed,
  .el-table__fixed-right {
    height: 680px !important;
  }
}
</style>
